
export const updateIn = (obj, path, updater) => {
  const [nextKey, ...nextPath] = path;
  const nextDefault = typeof nextPath[0] === 'number' ? [] : {};

  if (Array.isArray(obj)) {
    const ret = [...obj];
    ret[nextKey] = nextPath.length ?
      updateIn(obj[nextKey] || nextDefault, nextPath, updater) :
      updater(obj[nextKey]);
    return ret;
  } else {
    return {
      ...obj,
      [nextKey]: nextPath.length ?
        updateIn(obj[nextKey] || nextDefault, nextPath, updater) :
        updater(obj[nextKey]),
    };
  }
};

export const setIn = (obj, path, value) => {
  if (typeof path === 'string') {
    path = path.split('.');
  }
  return updateIn(obj, path, () => value);
};

export const getIn = (object, path) => path.reduce((acc = {}, p = []) => acc[p], object);